import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPlayIconSecondary from './svgs/PlayIconSecondary.js';
import SvgPlayIcon from './svgs/PlayIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var playIcon = (props => useIcon(SvgPlayIcon, SvgPlayIconSecondary, props));

export { playIcon as default };
